import { Modal } from 'antd';
import { FC } from 'react';
import { StarFilled } from '@ant-design/icons';
import styles from './index.module.scss';
import './index.scss';

interface ReviewPopupProps {
    isModalOpen: boolean;
    handleCancel: () => void;
    handleWriteReview: () => void;
    isLoading?: boolean;
}

const ReviewPopup: FC<ReviewPopupProps> = ({
    isModalOpen,
    handleCancel,
    handleWriteReview,
    isLoading = false,
}) => {
    return (
        <Modal
            open={isModalOpen}
            onCancel={handleCancel}
            className="review-popup-modal"
            closable={false}
            centered={true}
            width={520}
            footer={null}
            maskClosable={false}
        >
            <div className={styles['review-popup']}>
                <h2 className={styles['review-popup__title']}>
                    Love CostAllocation Pro?
                </h2>
                <p className={styles['review-popup__subtitle']}>
                    Help us out and leave us a review.
                </p>
                <div className={styles['review-popup__stars']}>
                    <StarFilled className={styles['review-popup__star']} />
                    <StarFilled className={styles['review-popup__star']} />
                    <StarFilled className={styles['review-popup__star']} />
                    <StarFilled className={styles['review-popup__star']} />
                    <StarFilled className={styles['review-popup__star']} />
                </div>
                <button
                    className={`${styles['review-popup__button']} ${isLoading ? styles['review-popup__button--disabled'] : ''
                        }`}
                    onClick={handleWriteReview}
                    disabled={isLoading}
                >
                    {isLoading ? 'Processing...' : 'Yes, I love CAP!'}
                </button>
                <button
                    className={`${styles['review-popup__dismiss']} ${isLoading ? styles['review-popup__dismiss--disabled'] : ''
                        }`}
                    onClick={handleCancel}
                    disabled={isLoading}
                >
                    No thanks, take me back to CostAllocation Pro.
                </button>
            </div>
        </Modal>
    );
};

export default ReviewPopup;

